import { render } from "./PersonnelHistoryRoute.vue?vue&type=template&id=44aa3b6b"
import script from "./PersonnelHistoryRoute.vue?vue&type=script&lang=js"
export * from "./PersonnelHistoryRoute.vue?vue&type=script&lang=js"

import "./PersonnelHistoryRoute.vue?vue&type=style&index=0&id=44aa3b6b&lang=scss"

import exportComponent from "/Users/user/Desktop/prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__